import React, { useMemo } from "react";

import { publicConfig } from "@/configs/public-config";
import { dictionaries } from "@/dictionaries/content";

import { type IProjectPayload } from "../../map-panel-context";

import { getProjectReviewStatusBadge } from "./project-review-status.utils";
import { SectionBasicInfoList } from "./section-basic-info-list";
import { SectionTitle } from "./section-title";
import { SectionTitleNavLink } from "./section-title-nav-link";

interface ProjectBasicInformationProps {
  payload: IProjectPayload | null;
}

export const ProjectBasicInformation: React.FC<
  ProjectBasicInformationProps
> = ({ payload }) => {
  const items = useMemo(() => {
    const reviewStatusBadge = getProjectReviewStatusBadge(
      payload?.reviewStatus,
    );
    const rows: Parameters<typeof SectionBasicInfoList>[0]["items"] = [
      { type: "text", head: "PROJECT NAME", value: payload?.name ?? "--" },
      { type: "text", head: "TYPE", value: payload?.projectType ?? "--" },
    ];
    if (publicConfig.shovelsIntegrationEnabled) {
      rows.push({
        type: "badge",
        head: "STATUS",
        value: reviewStatusBadge.label,
        variant: reviewStatusBadge.variant,
      });
    }
    rows.push({
      type: "text",
      head: "ADDRESS",
      value: payload?.address ?? "--",
    });

    return rows;
  }, [
    payload?.address,
    payload?.name,
    payload?.projectType,
    payload?.reviewStatus,
  ]);

  return (
    <div>
      <SectionTitle
        title="Basic Info"
        trailing={
          payload?.id ? (
            <SectionTitleNavLink
              href={`/panel/new-housing/${payload.id}`}
              label={dictionaries.mapPage.schoolPanel.goToFullInfo}
            />
          ) : undefined
        }
      />
      <SectionBasicInfoList items={items} />
    </div>
  );
};
